import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

import QuoteStore from '@ncl/modules/quote/store/QuoteStore';
import AccountStore from '@ncl/modules/account/store/AccountStore';
import * as services from './ZendeskWidget.services';

const ZendeskWidget = () => {
  const { Lead } = QuoteStore;
  const { currentUser } = AccountStore;

  const [ready, setReady] = useState(false);

  useEffect(() => {
    services.initApi(setReady);
  }, []);

  useEffect(() => {
    if (ready) {
      services.updateZIndex();
    }
  }, [ready]);

  useEffect(() => {
    if (ready && (Lead.nomeContato || currentUser.displayName)) {
      services.identifyLead();
    }
  }, [ready, Lead.nomeContato, currentUser.displayName]);

  return (
    <Helmet>
      <script
        id="ze-snippet"
        src="https://static.zdassets.com/ekr/snippet.js?key=bc0472b7-2750-4c35-af0b-11709f5af00c"
      />
    </Helmet>
  );
};

export default ZendeskWidget;
